import axios from "axios"
import { CREATIVES_URL } from "src/constants"

export const updateCreativeGroups = async (updates) => {
   return await axios.post(`${CREATIVES_URL}`, {
      updates,
   })
}
